module.exports = __webpack_public_path__ + "assets/outline-directions_run-24px.svg?eb3659dbedab17cab709e7d95f173a36";